import { Component, ojs, app, payload } from "modular-openscriptjs";
import { dom } from "../../../fotastart";
import { pageInfo } from "../../../helpers";
import { PAGES } from "../../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");
const route = app("router");

export default class ResetPassword extends Component {
    render(...args) {
        pageInfo(PAGES.RESET_PASSWORD);
        
        return h.div(
            h.div(
                { class: "page-reset-pass py-md-5" },
                h.div(
                    { class: "container" },
                    h.div(
                        { class: "col-md-8 col-lg-6 py-3 px-lg-3 mx-auto" },
                        h.h4({ class: "mb-3" }, "Reset Password"),
                        h.div(
                            { class: "form-field required-field" },
                            h.label({ for: "password" }, "New Password:"),
                            h.input({
                                type: "password",
                                name: "password",
                                id: "password",
                                class: "form-control",
                                required: "",
                            }),
                            h.div({ class: "help-block" })
                        ),
                        h.div(
                            { class: "form-field required-field mb-4" },
                            h.label(
                                { for: "password-confirm" },
                                "Confirm Password:"
                            ),
                            h.input({
                                type: "password",
                                name: "password_confirmation",
                                id: "password-confirm",
                                class: "form-control",
                                required: "",
                            }),
                            h.div({ class: "help-block" })
                        ),
                        h.div(
                            { class: "text-xs-right" },
                            h.button(
                                {
                                    type: "button",
                                    class: "btn btn-rounded btn-success mb-5",
                                    onclick: this.method("submit"),
                                },
                                h.span({ class: "me-2" }, "Submit"),
                                h.i({ class: "fa-solid fa-check" })
                            )
                        )
                    )
                )
            ),

            ...args
        );
    }

    submit() {
        let email = route.qs.get("email");
        let token = route.qs.get("token");
        let password = dom.id("password")?.value;
        let password_confirmation = dom.id("password-confirm")?.value;

        broker.broadcast(
            $e.user.needs.password.reset,
            payload({ email, token, password, password_confirmation })
        );
    }
}

ojs(ResetPassword);
